module.exports = __webpack_public_path__ + "img/lock.e2a7c448.png";